import { SVGProps } from 'react'

export const DenoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    viewBox="0 0 40 40"
    fill="none"
    {...props}
  >
    <mask
      id="deno-a"
      style={{
        maskType: 'alpha'
      }}
      maskUnits="userSpaceOnUse"
      x={3}
      y={3}
      width={32}
      height={32}
    >
      <path
        d="M19 34.273c8.435 0 15.273-6.838 15.273-15.273 0-8.435-6.838-15.273-15.273-15.273-8.435 0-15.273 6.838-15.273 15.273 0 8.435 6.838 15.273 15.273 15.273Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#deno-a)">
      <path
        d="M19 36c9.389 0 17-7.611 17-17S28.389 2 19 2 2 9.611 2 19s7.611 17 17 17ZM6.715 23.184 7.844 19Zm2.454-10.486 1.13-4.184Zm-4.717 3.978 1.13-4.184Zm5.913 10.89 1.129-4.183Zm2.285 6.762 1.129-4.183Zm4.623-2.025 1.13-4.183ZM15.697 8.148l1.129-4.183Zm7.978 5.34 1.129-4.183Zm8.353 8.745 1.129-4.183Zm-2.86-5.557 1.13-4.184Zm-7.31-11.053 1.128-4.184Zm6.746 2.092 1.129-4.184Z"
        fill="#000"
      />
      <path
        d="M6.715 23.184 7.844 19m1.325-6.302 1.13-4.184m-5.847 8.162 1.13-4.184m4.783 15.074 1.129-4.183m1.156 10.945 1.129-4.183m3.494 2.158 1.13-4.183M15.696 8.147l1.129-4.183m6.849 9.524 1.129-4.184m7.224 12.928 1.129-4.183m-3.989-1.374 1.13-4.184m-8.44-6.869 1.128-4.184m5.618 6.276 1.129-4.184"
        stroke="#fff"
        strokeWidth={0.83}
        strokeLinecap="round"
      />
      <path
        d="M18.75 24.872c-5.755.173-9.601-2.291-9.601-6.267 0-4.083 4.006-7.38 9.187-7.38 2.502 0 4.617.707 6.268 1.998a8.959 8.959 0 0 1 3.023 4.403c.17.552 1.518 5.563 4.058 15.094l.086.323-10.611 4.943-.073-.535c-.588-4.302-1.099-7.526-1.532-9.671-.215-1.063-.41-1.857-.584-2.377a2.92 2.92 0 0 0-.22-.528c0-.001 0-.002-.002-.003Z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.398}
      />
      <path
        d="M19.398 16.543a1.063 1.063 0 1 0 0-2.125 1.063 1.063 0 0 0 0 2.125Z"
        fill="#000"
      />
    </g>
  </svg>
)
